import { memo, useCallback, useEffect } from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__, __ANDROID__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setNavMode } from './actions';
import { getCurrentEmployer } from '../../selectors/entities';

import SelectCaseBtn from '../cases/select_case_button';

function mapStateToProps(state) {
  return {
    navMode: state.screens.messaging.navMode,
    employer: getCurrentEmployer(state),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ setNavMode }, dispatch),
  };
}

const NavItem = function (props) {
  const mode = props.mode;
  const pressHandler = useCallback(
    function () {
      props.actions.setNavMode(mode);
    },
    [mode]
  );

  return (
    <Pressable
      style={[styles.item, props.navMode === props.mode ? styles.selected : null]}
      onPress={pressHandler}
    >
      <Text style={THEME.textSemibold}>{props.label}</Text>
    </Pressable>
  );
};

export default memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )((props) => {
    if (!props.employer) return null;
    const patientMode = props.navMode === 'patient';
    return (
      <View style={styles.container}>
        <View style={styles.buttonsContainer}>
          <NavItem {...props} mode="provider" label="Provider" />
          <NavItem {...props} mode="oncall" label="On-Call" />
          <NavItem
            {...props}
            mode="patient"
            label={patientMode && __WEB__ ? 'Patient: ' : __WEB__ ? 'Patient  ' : 'Patient'}
          />
        </View>

        {!!(__WEB__ && patientMode) ? (
          <View style={{ justifyContent: 'center' }}>
            <SelectCaseBtn
              canSeeAllResidentsOption={false}
              showAllResidents={false}
              containerStyle={{ width: 250 }}
            />
          </View>
        ) : (
          <View style={{ width: 250 }} />
        )}
      </View>
    );
  })
);

const styles = StyleSheet.create({
  container: __WEB__
    ? {
        flex: 1,
        ...THEME.basicRow,
        alignItems: 'stretch',
        alignSelf: 'stretch',
      }
    : {
        flex: 1,
      },
  buttonsContainer: __WEB__
    ? {
        flex: 1,
        minWidth: 350,
        maxWidth: 500,
        ...THEME.basicRow,
        alignItems: 'stretch',
        alignSelf: 'stretch',
      }
    : {
        flex: 1,
        ...THEME.basicRow,
        alignItems: 'stretch',
        alignSelf: 'stretch',
      },
  item: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: 7,
    paddingHorizontal: 17,
    alignItems: 'center',
    justifyContent: 'center',
  },
  selected: {
    borderBottomWidth: 1,
    borderColor: COLOR.emphasis,
  },
});
